var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14,3.41421356 L4,13.4142136 L4,16 L6.58578644,16 L16.5857864,6 L14,3.41421356 Z M14.7071068,1.29289322 L18.7071068,5.29289322 C19.0976311,5.68341751 19.0976311,6.31658249 18.7071068,6.70710678 L7.70710678,17.7071068 C7.5195704,17.8946432 7.26521649,18 7,18 L3,18 C2.44771525,18 2,17.5522847 2,17 L2,13 C2,12.7347835 2.10535684,12.4804296 2.29289322,12.2928932 L13.2928932,1.29289322 C13.6834175,0.902368927 14.3165825,0.902368927 14.7071068,1.29289322 Z M3,23 C2.44771525,23 2,22.5522847 2,22 C2,21.4477153 2.44771525,21 3,21 L21,21 C21.5522847,21 22,21.4477153 22,22 C22,22.5522847 21.5522847,23 21,23 L3,23 Z"}));
}

Edit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Edit;

Edit.default = Edit;
